import isEmpty from 'lodash.isempty';
import { FormStatus } from './types';

function getDialogueType(formStatus: FormStatus): 'custom' | 'success' | 'error' {
  if (isEmpty(formStatus.status) || !formStatus.status.messageIcon) {
    return 'custom';
  }

  return formStatus.status.messageIcon === 'alert' ? 'error' : 'success';
}

export function buildDialogueProps(formStatus: FormStatus, size: 'l' | 'xl') {
  const dialogueType = getDialogueType(formStatus);

  const commonProps = {
    size,
    noFooterButton: true,
    closeDialogue: () => {},
  };

  if (dialogueType === 'custom') {
    return {
      ...commonProps,
      type: dialogueType,
      titleLabel: '',
    };
  }

  return {
    ...commonProps,
    type: dialogueType,
    headerLabel: dialogueType === 'error' ? 'Error' : 'Success',
    bodyContent:
      dialogueType === 'error'
        ? formStatus.submitMessages.error
        : formStatus.submitMessages.success,
    headerSymbol: dialogueType === 'error' ? 'WarningSevere' : 'Check',
  };
}
